<template>
  <div class="student-gains-list-component">
    <grid-item v-for="item in list"
               :key="item.id"
               :item="item"
    />
  </div>
</template>

<script>
  import GridItem from '@/pages/StudentGains/components/StudentGainsGridItem';

  export default {
    name: 'StudentGainsList',
    components: {
      GridItem,
    },
    props: {
      list: {
        type: Array,
        required: true,
        default() {
          return [];
        },
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .student-gains-list {
    &-component {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      padding: 0 @size-medium;
    }
  }
</style>
